import { motion } from "framer-motion";
import { LeafMark, scrollToId } from "@/lib/site";

const LINKS = [
  { label: "Benefits", id: "benefits" },
  { label: "What's Inside", id: "inside" },
  { label: "Reviews", id: "reviews" },
  { label: "FAQ", id: "faq" },
];

export default function Navbar() {
  return (
    <motion.header
      initial={{ y: -70, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className="bg-[#FAF7F2]/80 backdrop-blur-md border-b border-[#1C3A27]/10"
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-[72px] flex items-center justify-between">
        <button
          onClick={() => window.__lenis?.scrollTo(0)}
          className="flex items-center gap-2.5 group"
          data-testid="nav-logo"
        >
          <LeafMark className="w-9 h-9 transition-transform duration-500 group-hover:rotate-[8deg]" />
          <span className="font-display text-xl font-bold tracking-tight text-[#1C3A27]">
            TeaMethod<span className="text-[#D4A359]">.</span>
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-8" data-testid="nav-links">
          {LINKS.map((l) => (
            <button
              key={l.id}
              onClick={() => scrollToId(l.id)}
              className="text-sm font-semibold text-[#5C6A60] hover:text-[#1C3A27] transition-colors duration-300 relative after:absolute after:-bottom-1 after:left-0 after:h-[2px] after:w-0 after:bg-[#D4A359] after:transition-all after:duration-300 hover:after:w-full"
              data-testid={`nav-link-${l.id}`}
            >
              {l.label}
            </button>
          ))}
        </nav>

        <motion.button
          whileHover={{ scale: 1.04 }}
          whileTap={{ scale: 0.97 }}
          onClick={() => scrollToId("pricing")}
          className="rounded-full bg-[#1C3A27] text-[#FAF7F2] text-sm font-bold px-5 py-2.5 hover:bg-[#12261A] transition-colors duration-300"
          data-testid="nav-cta-button"
        >
          Get the Guide — $22
        </motion.button>
      </div>
    </motion.header>
  );
}
